module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fCKE7"))).then(() => parcelRequire('d0iPb'));